exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_playlists_1ANVeEzvOVYQ6oF0GZeQ6g {\n  position: relative;\n  width: 100%;\n  height: auto;\n  float: left;\n}\n\n.IA_filters_3RXfBoGQyQ8dxUFF_rmU3y {\n  width: 100%;\n  margin-bottom: 10px;\n  display: flex;\n  flex-direction: row;\n}\n\n.IA_paginationButtonContainer_1LjPeqCELfhQ6DS98oSPyo {\n  width: 100%;\n  height: 30px;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  margin-top: 20px;\n}\n\n.IA_paginationPageCount_1GFvbhFY9stV5rtfVcO2HK {\n  text-align: center;\n}", ""]);

// Exports
exports.locals = {
	"IA_playlists": "IA_playlists_1ANVeEzvOVYQ6oF0GZeQ6g",
	"IA_filters": "IA_filters_3RXfBoGQyQ8dxUFF_rmU3y",
	"IA_paginationButtonContainer": "IA_paginationButtonContainer_1LjPeqCELfhQ6DS98oSPyo",
	"IA_paginationPageCount": "IA_paginationPageCount_1GFvbhFY9stV5rtfVcO2HK"
};